import { digitalConnectionPointTypes, previousStepConectionPointTypes, spotConnectionPointTypes, tagSourceConnectionPointTypes } from '../../../common/constants';
import { ConnectionPoint } from '../../../models/ConnectionPoint';
import { Miniature } from '../../../models/miniature';
import { DigitalMiniature } from './DigitalMiniature';
import { FloatMiniature } from './FloatMiniature';
import { PreviousStepMiniature } from './PreviousStepMiniature';
import { SpotMiniature } from './SpotMiniature';

export function getTagsMiniatures(connectionPoints: ConnectionPoint[]): Miniature[] {
    const miniatures: Miniature[] = [];
    const hasAcquisition = getFloatConnectionPoints(connectionPoints).length > 0;
    if (hasAcquisition) {
        miniatures.push(FloatMiniature);
    }
    const hasDigital = getDigitalConnectionPoints(connectionPoints).length > 0;
    if (hasDigital) {
        miniatures.push(DigitalMiniature);
    }
    const hasPreviousStep = getPreviousStepConnectionPoints(connectionPoints).length > 0;
    if (hasPreviousStep) {
        miniatures.push(PreviousStepMiniature);
    }
    const hasSpot = getSpotConnectionPoints(connectionPoints).length > 0;
    if (hasSpot) {
        miniatures.push(SpotMiniature);
    }
    return miniatures;
}

export function getFloatConnectionPoints(connectionPoints: ConnectionPoint[]):  ConnectionPoint[]{
    return connectionPoints
        .filter(cp => tagSourceConnectionPointTypes.indexOf(cp.type) >= 0);
}

export function getDigitalConnectionPoints(connectionPoints: ConnectionPoint[]):  ConnectionPoint[]{
    return connectionPoints
        .filter(cp => digitalConnectionPointTypes.indexOf(cp.type) >= 0);
}

export function getPreviousStepConnectionPoints(connectionPoints: ConnectionPoint[]):  ConnectionPoint[]{
    return connectionPoints
        .filter(cp => previousStepConectionPointTypes.indexOf(cp.type) >= 0);
}

export function getSpotConnectionPoints(connectionPoints: ConnectionPoint[]):  ConnectionPoint[]{
    return connectionPoints
        .filter(cp => spotConnectionPointTypes.indexOf(cp.type) >= 0);
}